import * as React from 'react';
import { UpdateSingleDoc } from '../NetworkCalls/Admin/ServerReq';

export default function MenuSelect({rowID ,status }) {
  const [_package, setPackage] = React.useState(status);
  console.log(_package)

  const handleChange = async(event) => {
    setPackage(event.target.value);

     await UpdateSingleDoc("Restaurants", rowID, { status: event.target.value });



  };

  return (
    <select
      style={{
        padding: '7px',
        width: '100%',
        fontSize: '15px',
        border: '1px solid gray',
        cursor: 'pointer',
      }}
      onChange={handleChange}
      value={_package}
    >
      <option value="General">General</option>
      <option value="Featured">Featured</option>
    </select>
  );
}
